import * as React from 'react';

import { IEvidentlyProvider, FeatureEvaluation } from './types';

export { IEvidentlyProvider, FeatureEvaluation };

export async function evidently(): Promise<IEvidentlyProvider> {
	const { evidentlyProvider } = await import(/* webpackChunkName: 'evidently' */ './providers');
	return evidentlyProvider;
}

export const EvidentlyOverridesWidget = React.lazy(() => import(/* webpackChunkName: 'evidently' */ './overrides'));
